document.addEventListener('click', function (event) {
  var chip = event.target.closest('[data-si-chip]');
  if (!chip) return;

  var widget = chip.closest('.si-widget');
  if (!widget) return;

  var index = chip.getAttribute('data-index');

  var chips = widget.querySelectorAll('[data-si-chip]');
  chips.forEach(function (c) {
    var isActive = c === chip;
    c.classList.toggle('is-active', isActive);
    c.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  var panels = widget.querySelectorAll('[data-si-panel]');
  panels.forEach(function (p) {
    p.classList.toggle('is-active', p.getAttribute('data-index') === index);
  });
});